import axios from 'axios';
  export default {
 	// 地区树数据
 	areaOptions: null,
 	// 加载地区树数据
 	async loadRegionTree() {
 		if (this.areaOptions) {
 			return this.areaOptions;
 		}
 		return await this.reloadRegionTree();
 	},
 	// 重新加载地区树数据（修改JSON文件后调用）
 	async reloadRegionTree() {
 		try {
 			const response = await axios.get('/regionTree.json', {
 				baseURL: '', // 不使用baseURL
 				withoutToken: true // 不需要token
 			});
 			this.areaOptions = response.data;
 			return response.data;
 		} catch (error) {
 			console.error('加载地区树数据失败:', error);
 			return [];
 		}
 	},
	// 主营产品树
	mainProductTree:null,
	// 加载主营产品树数据
	async loadMainProductTree() {
		if (this.mainProductTree) {
			return this.mainProductTree;
		}
		return await this.reloadMainProductTree();
	},
	// 重新加载主营产品树数据（修改JSON文件后调用）
	async reloadMainProductTree() {
		try {
			const response = await axios.get('/mainProductTree.json', {
				baseURL: '', // 不使用baseURL
				withoutToken: true // 不需要token
			});
			this.mainProductTree = response.data;
			return response.data;
		} catch (error) {
			console.error('加载主营产品树数据失败:', error);
			return [];
		}
	},
	// 国民经济分类
	gmjjflList:[],
	// 行业类型--试点
	industryTypeList:[],
	// 行业类型--服务商--全部
	industryTypeListFWS:[],
	// 场景类型
	sceneTypeList:[],
	// 区域--试点
	regionOptions:[],
	// 区域--服务商--全部
	regionOptionsFWS:[],
	// 企业类型
	enterpriseType:[
	{
		dictLabel:'国有企业',
		dictValue:'state_owned_enterprise'
	},
	{
		dictLabel:'集体企业',
		dictValue:'collective_enterprise'
	},
	{
		dictLabel:'股份合作企业',
		dictValue:'joint_stock_cooperative_enterprise'
	},
	{
		dictLabel:'联营企业',
		dictValue:'joint_venture'
	},
	{
		dictLabel:'有限责任公司',
		dictValue:'limited_liability_company'
	},
	{
		dictLabel:'股份有限公司',
		dictValue:'joint_stock_company'
	},
],
// 企业规模
	scaleList:[
		{
			dictLabel:'大型',
			dictValue:'ent_scale_large'
		},
		{
			dictLabel:'中型',
			dictValue:'ent_scale_medium'
		},
		{
			dictLabel:'小型',
			dictValue:'ent_scale_small'
		},
		{
			dictLabel:'微型',
			dictValue:'ent_scale_micro'
		},
	],
	// 规模范围
	companyRange:[
		{
			dictLabel:'规模以上企业',
			dictValue:'scale_above'
		},
		{
			dictLabel:'规模以下企业',
			dictValue:'scale_below'
		},
	],
	// 优质中小企业情况
	enterpriseSituationList:[
		{
			dictLabel:'创新型中小企业',
			dictValue:'Innovative'
		},
		{
			dictLabel:'专精特新中小企业',
			dictValue:'mastery'
		},
		{
			dictLabel:'专精特新“小巨人”企业',
			dictValue:'littleGiant'
		},
		{
			dictLabel:'无',
			dictValue:'nothing'
		},
	],
	// 所属细分行业
	xfhyType:[
		{
	    label: "智能制造装备",
	    value: '1'
	  },
		{
	    label: "先进交通装备及关键零部件制造",
	    value: '2',
	  },
		{
	    label: "时尚健康消费品制造",
	    value: '3',
	  },
		{
	    label: "其他",
	    value: '4',
	  },
	],
	xfhyType2:[
		{
	    label: "智能制造装备",
	    value: '1'
	  },
		{
	    label: "先进交通装备及关键零部件制造",
	    value: '2',
	  },
		{
	    label: "时尚健康消费品制造",
	    value: '3',
	  },
	],
	// 数字化等级
	digitalLevelList:[
		{
			dictLabel:'四级（协同级）',
			dictValue:'level_four'
		},
		{
			dictLabel:'三级（集成级）',
			dictValue:'level_three'
		},
		{
			dictLabel:'二级（规范级）',
			dictValue:'level_two'
		},
		{
			dictLabel:'一级（初始级）',
			dictValue:'level_one'
		},
		{
			dictLabel:'无等级',
			dictValue:'none_level'
		},
	],
	// 产品-服务场景-需求类型
	serverScence:[
		{
			value:'1',
			label:'诊断咨询设计',
		},{
			value:'2',
			label:'数字化基础设施',
			children:[
				{
					value:'3',
					label:'网络服务',
				},
				{
					value:'4',
					label:'云服务',
				},{
					value:'5',
					label:'工业互联网平台服务',
				},
			],
		},
		{
			value:'6',
			label:'应用场景解决方案',
			children:[
				{
					value:'7',
					label:'研发设计',
				},
				{
					value:'8',
					label:'生产制造',
				},{
					value:'9',
					label:'质量管理',
				},
				{
					value:'10',
					label:'运营管理',
				},
				{
					value:'11',
					label:'仓储物流',
				},
				{
					value:'12',
					label:'工业互联网平台',
				},
			],
		},
		{
			value:'13',
			label:'其他',
		}
	],
	// 产品-部署方式
	deployTypeList:[
		{
			dictValue:'PC',
			dictLabel:'PC 单机部署',
		},
		{
			dictValue:'C_S',
			dictLabel:'C/S',
		},
		{
			dictValue:'B_S',
			dictLabel:'B/S',
		},
		{
			dictValue:'OFFLINE_DEPLOYMENT',
			dictLabel:'单机部署',
		},
		{
			dictValue:'CLUSTER_DEPLOYMENT',
			dictLabel:'多机/集群部署',
		},
		{
			dictValue:'MICROSERVICE_DEPLOYMENT',
			dictLabel:'微服务架构部署',
		},
		{
			dictValue:'CONTAINERIZED_DEPLOYMENT',
			dictLabel:'容器化部署',
		},
		{
			dictValue:'MIXED_DEPLOYMENT',
			dictLabel:'混合部署',
		},
		{
			dictValue:'EDGE_COMPUT_DEPLOYMENT',
			dictLabel:'边缘计算部署',
		},
		{
			dictValue:'CLOUD_NATIVE_DEPLOYMENT',
			dictLabel:'云原生部署',
		},
		{
			dictValue:'Deployment_other',
			dictLabel:'其他',
		},
	],
	// 产品-购买方式
	buyTypeList:[
		{
			dictValue:'disposable',
			dictLabel:'一次性购买',
		},
		{
			dictValue:'purchase',
			dictLabel:'按需购买',
		},
		{
			dictValue:'subscribe',
			dictLabel:'订阅',
		},
		{
			dictValue:'month_bill',
			dictLabel:'包月计费',
		},
		{
			dictValue:'year_bill',
			dictLabel:'包年计费',
		},
		{
			dictValue:'demand_bill',
			dictLabel:'按需计费',
		},
		{
			dictValue:'Pay_other',
			dictLabel:'其他',
		},
	],
	// 项目进度
	statusProgress:[
		{
			value:'0',
			label:'项目启动',
		},
		{
			value:'1',
			label:'项目启动失败',
		},
		{
			value:'2',
			label:'实施中',
		},
		{
			value:'3',
			label:'实施失败',
		},
		{
			value:'4',
			label:'项目结项',
		},
		{
			value:'5',
			label:'验收中',
		},
		{
			value:'6',
			label:'验收失败',
		},
		{
			value:'7',
			label:'已验收',
		},
	],
	// 暂时用不到了
	noType:[
		{
			name:'农、林、牧、渔业',
			value:1
		},
		{
			name:'工业',
			value:2
		},
		{
			name:'建筑业',
			value:3
		},
		{
			name:'批发业',
			value:4
		},
		{
			name:'零售业',
			value:5
		},
		{
			name:'交通运输业',
			value:6
		},
		{
			name:'仓储业',
			value:7
		},
		{
			name:'邮政业',
			value:8
		},
		{
			name:'住宿业',
			value:9
		},
		{
			name:'餐饮业',
			value:10
		},
		{
			name:'信息传输业',
			value:11
		},
		{
			name:'软件和信息技术服务业',
			value:12
		},
		{
			name:'房地产开发经营',
			value:13
		},
		{
			name:'物业管理',
			value:14
		},
		{
			name:'租赁和商务服务业',
			value:15
		},
		{
			name:'其他未列明行业',
			value:16
		},
	],
	cpTypeListNew:[
	  {
	    name: "全部",
	    value: 0
	  },
		{
	    name: "食品",
	    value: 3,
	  },
		{
	    name: "鞋品",
	    value: 8,
	  },
		{
	    name: "纺织品",
	    value: 5,
	  },
		{
	    name: '印刷品',
	    value: 10,
	  },
		{
	    name: "医药制品",
	    value: 13,
	  },
		{
		  name: "仪器仪表",
		  value: 26, 
	  },
		{
			name: "金属制品",
			value: 19, 
		 },
		 {
			name: "通用设备",
			value: 20,  
		 },
		 {
			 name: "专用设备",
			 value: 21,
		 },
	  {
	    name: "汽车制造",
	    value: 1,
	  },
		
	  {
	    name: "农副食品",
	    value: 2,
	  },
		{
	    name: "纺织服装、服饰",
	    value: 7,
	  },
	  {
	    name: "酒、饮料和精制茶",
	    value: 4,
	  },
	  {
	    name: "化学纤维制品",
	    value: 14,
	  },
	  {
	    name: "橡胶和塑料制品",
	    value: 15,
	  },
	  {
	    name: "非金属矿物制品",
	    value: 16,
	  },
		{
		  name: "电气机械和器材",
		  value: 24,
	  },
		{
		  name: "石油和天然气开采",
		  value: 22,
	  },
		{
	    name: "化学原料和化学制品",
	    value: 12,
	  },
	
	  {
	    name: "黑色金属冶炼和压延",
	    value: 17,
	  },
	  {
	    name: "有色金属冶炼和压延",
	    value: 18,
	  },
	
	  {
		 name: "计算机、通信等电子设备",
		 value: 25, 
	  },
	  {
		  name: "金属制品、机械和设备修理",
		  value: 27, 
	  },
	
	  {
	    name: '文教、工美、体育和娱乐用品',
	    value: 11,
	  },

	  {
		  name: "铁路、船舶、航空航天等设备",
		  value: 23,
	  },
		{
	    name: "木材加工和木、竹、藤、棕、草制品",
	    value: 9,
	  },
	  {
		  name: "其他",
		  value: 28, 
	  }
	],
	jigouList:[
	  {
	    name: "全部",
	    value: 0
	  },
	  {
	    name: "采购需求",
	    value: 1,
	  },
	  {
	    name: "融资需求",
	    value: 2,
	  },
	  {
	    name: '服务需求',
	    value: 3,
	    children: [
	      {
	        name: '创业服务',
	        value: 31,
	      },
	      {
	        name: '人才培训',
	        value: 32,
	      },
	      {
	        name: '技术与质量服务',
	        value: 33,
	      },
	      {
	        name: '信息化服务',
	        value: 34,
	      },
	      {
	        name: '管理咨询服务',
	        value: 35,
	      },
	      {
	        name: '市场开拓服务',
	        value: 36,
	      },
	      {
	        name: '法律服务',
	        value: 37,
	      },
	      {
	        name: "其他服务",
	        value: 38
	      },
	    ]
	  },
	],
	zzjgList:[
		{
			name: "全部",
			value: 0
		},
		{
			name: "投融资服务",
			value: 2
		},
		{
			name: "创业服务",
			value: 3
		},
		{
			name: "人才培训",
			value: 4
		},

		{
			name: "技术与质量服务",
			value: 5
		},
		{
			name: "信息化服务",
			value: 1
		},
		{
			name: "管理咨询服务",
			value: 6
		},
		{
			name: "市场开拓服务",
			value: 7
		},
		{
			name: "法律服务",
			value: 8
		},
		{
			name: "其他服务",
			value: 9
		},
	],
 	hangyeList :[
		{
			name: "全部",
			value: 0,
		},

		{
			name: "生物医药",
			value: 1,
			children: [
				{
					name: '中药',
					value: 11,
				},
				{
					name: '化学制药',
					value: 12,
				},
				{
					name: '生物制药',
					value: 13,
				},
				{
					name: '医疗器械',
					value: 14,
				},
				{
					name: '其他',
					value: 15,
				}
			]
		},
		{
			name: "装备制造",
			value: 2,
			children: [
				{
					name: '轨道交通',
					value: 21,
				},
				{
					name: '智能制造',
					value: 22,
				},
				// {
				//   name: ' 装备制造',
				//   value: 23,
				// },
				// {
				//   name: '高端装备',
				//   value: 24,
				// },
				{
					name: '其他',
					value: 25,
				}
			]
		},
		{
			name: "汽车及零部件",
			value: 3,
			children: [
				{
					name: '传统汽车及零部件',
					value: 31,
				},
				{
					name: '新能源（智能联网）车',
					value: 32,
				},
				{
					name: '其他',
					value: 33,
				}
			]
		},
		{
			name: "新材料",
			value: 4,
			children: [
				{
					name: '高端金属材料',
					value: 41,
				},
				{
					name: '新型无机非金属材料',
					value: 42,
				},
				{
					name: '新一代信息技术材料',
					value: 43,
				},
				{
					name: '其他',
					value: 44,
				}
			]
		},
		{
			name: "轻工",
			value: 5,
			children: [
				{
					name: '自行车',
					value: 51,
				},
				{
					name: '地毯',
					value: 52,
				},
				{
					name: '食品饮料',
					value: 53,
				},
				{
					name: '纺织服装',
					value: 54,
				},
				{
					name: '绢花',
					value: 55,
				},
				{
					name: '其他',
					value: 56,
				}
			]
		},
		{
			name: "智能科技",
			value: 6,
			children: [
				{
					name: '云数据应用',
					value: 61,
				},
				{
					name: '人工智能',
					value: 62,
				},
				{
					name: '数字技术服务',
					value: 63,
				},
				{
					name: '数字产品制造',
					value: 64,
				},
				{
					name: '其他',
					value: 65,
				}
			]
		},
		{
			name: "其他",
			value: 7
			,
		},
	],
	shenbaoList:[
	  {
	    name: "全部",
			type:'0'
	  },
	  {
	    name: "未开始",
			type:'1'
	  },
	  {
	    name: "申报中",
			type:'2'
	  },
	  {
	    name: "已结束",
			type:'3'
	  },
	],
	itemList:[
	  {
	    name: "全部",
			type:'0'
	  },
	  {
	    name: "专精特新",
			type:'1'
	  },
	  {
	    name: "智能制造",
			type:'2'
	  },
	],
	zhdTypeArr :[
	  {
	    name: "全部",
		value:0
	  },
	  {
	    name: "洽谈会",
		value:1
	  },
	  {
	    name: "撮合会",
		value:2
	  },
	  {
	    name: "政策宣传",
		value:3
	  },
	  {
	    name: "产业提升",
		value:4
	  },
	  {
	    name: "人才培育",
		value:5
	  },
	  {
	    name: "科技创新",
		value:6
	  },
	  {
	    name: "其他",
		value:7
	  },
	],
	gsgmOptions:[
		{
			name:"小于50人",
			value:0
		},
		{
			name:"50-99人",
			value:1
		},
		{
			name:"100-499人",
			value:2
		},
		{
			name:"500人以上",
			value:3
		}
	],
	qylxList: [
	  {
	    name: "内资企业",
	    id: 1,
	    children: [
	      {
	        name: "国有企业",
	        id: 101,
	      }, {
	        name: "集体企业",
	        id: 102,
	      },
	      {
	        name: "股份合作企业",
	        id: 103,
	      },
	      {
	        name: "国有联营企业",
	        id: 104,
	      },
	      {
	        name: "国有独资公司",
	        id: 105,
	      },
	      {
	        name: "股份有限公司",
	        id: 106,
	      },
	      {
	        name: "私营独资",
	        id: 107,
	      },
	      {
	        name: '其他企业',
	        id: 108,
	      },
	      {
	        name: '集体联营企业',
	        id: 109,
	      },
	      {
	        name: '国有与集体联营',
	        id: 110,
	      },
	      {
	        name: '其他联营',
	        id: 111,
	      },
	      {
	        name: '其他有限责任公司',
	        id: 112,
	      },
	      {
	        name: "私营合伙",
	        id: 113,
	      },
	      {
	        name: "私营有限责任公司",
	        id: 114,
	      },
	      {
	        name: "私营股份有限公司",
	        id: 115,
	      }
	    ]
	  },
	  {
	    name: '港、澳、台商投资企业',
	    id: 2,
	    children: [
	      {
	        name: '合资经营企业（港或澳、台资）',
	        id: 201
	      },
	      {
	        name: "合作经营企业（港或澳、台资）",
	        id: 202
	      },
	      {
	        name: '港、澳、台商独资经营企业',
	        id: 203
	      },
	      {
	        name: '港、澳、台商投资股份有限公司',
	        id: 204
	      },
	      {
	        name: '其他港、澳、台商投资企业',
	        id: 205
	      }
	    ]
	  },
	  {
	    name: "外商投资企业",
	    id: 3,
	    children: [
	      {
	        name: '中外合资经营企业',
	        id: 301
	      },
	      {
	        name: '中外合作经营企业',
	        id: 302
	      },
	      {
	        name: '外资企业',
	        id: 303
	      },
	      {
	        name: '外商投资股份有限公司',
	        id: 304
	      },
	      {
	        name: '其他外商投资企业',
	        id: 305
	      }
	    ]
	  }
	],
	zzlxListNew:[
	  {
	    name: "专精特新小巨人",
	    id: 11,
	  },
	  {
	    name: "专精特新中小企业",
	    id: 12,
	  },
	  {
	    name: '市企业技术中心',
	    id: 21
	  },
	  {
	    name: "国家级企业技术中心",
	    id: 22
	  },
	  {
	    name: '国家技术创新示范企业',
	    id: 23
	  },
	  {
	    name: '市级单冠',
	    id: 31
	  },
	  {
	    name: '国家级单冠',
	    id: 32
	  },
	  {
	    name: '无',
	    id: 0
	  }
	],
	hangyeListNew:[
	
	  {
	    name: "生物医药",
	    value: 1,
	    children: [
	      {
	        name: '中药',
	        value: 11,
	      },
	      {
	        name: '化学制药',
	        value: 12,
	      },
	      {
	        name: '生物制药',
	        value: 13,
	      },
	      {
	        name: '医疗器械',
	        value: 14,
	      },
	      {
	        name: '其他',
	        value: 15,
	      }
	    ]
	  },
	  {
	    name: "装备制造",
	    value: 2,
	    children: [
	      {
	        name: '轨道交通',
	        value: 21,
	      },
	      {
	        name: '智能制造',
	        value: 22,
	      },
	
	      // {
	      //   name: ' 装备制造',
	      //   value: 23,
	      // },
	      // {
	      //   name: '高端装备',
	      //   value: 24,
	      // },
	      {
	        name: '其他',
	        value: 25,
	      }
	    ]
	  },
	  {
	    name: "汽车及零部件",
	    value: 3,
	    children: [
	      {
	        name: '传统汽车及零部件',
	        value: 31,
	      },
	      {
	        name: '新能源（智能联网）车',
	        value: 32,
	      },
	      {
	        name: '其他',
	        value: 33,
	      }
	    ]
	  },
	  {
	    name: "新材料",
	    value: 4,
	    children: [
	      {
	        name: '高端金属材料',
	        value: 41,
	      },
	      {
	        name: '新型无机非金属材料',
	        value: 42,
	      },
	      {
	        name: '新一代信息技术材料',
	        value: 43,
	      },
	      {
	        name: '其他',
	        value: 44,
	      }
	    ]
	  },
	  {
	    name: "轻工",
	    value: 5,
	    children: [
	      {
	        name: '自行车',
	        value: 51,
	      },
	      {
	        name: '地毯',
	        value: 52,
	      },
	      {
	        name: '食品饮料',
	        value: 53,
	      },
	      {
	        name: '纺织服装',
	        value: 54,
	      },
	      {
	        name: '绢花',
	        value: 55,
	      },
	      {
	        name: '其他',
	        value: 56,
	      }
	    ]
	  },
	  {
	    name: "智能科技",
	    value: 6,
	    children: [
	      {
	        name: '云数据应用',
	        value: 61,
	      },
	      {
	        name: '人工智能',
	        value: 62,
	      },
	      {
	        name: '数字技术服务',
	        value: 63,
	      },
	      {
	        name: '数字产品制造',
	        value: 64,
	      },
	      {
	        name: '其他',
	        value: 65,
	      }
	    ]
	  },
	  {
	    name: "其他",
	    value: 7
	    ,
	  },
	],
	fwlbOptions:[
		{
			name:'信息服务',
			value:1
		},
		{
			name:'投融资',
			value:2
		},
		{
			name:'创业服务',
			value:3
		},
		{
			name:'人才培训',
			value:4
		},
		{
			name:'技术创新与力量',
			value:5
		},
		{
			name:'管理咨询',
			value:6
		},
		{
			name:'市场开拓',
			value:7
		},
		{
			name:'法律服务',
			value:8
		},
		{
			name:'其它',
			value:9
		},
	],
	userTypeOptions:[
		{
			name:'企业',
			value:1
		},
		{
			name:'服务机构',
			value:2
		}
	],
	townPark:[
		{
			name:'全部',
			value:100
		},
	],
}